// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"12c4e2c0","491":"bf67077e"}[chunkId] + ".chunk.js";
};